import { Select, Typography } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import React, { memo } from 'react';

import { L } from '@lib';

const { Text } = Typography;
const { Option } = Select;

interface IProps {
  disabled?: boolean;
  hideFirstOption?: boolean;
  value?: string;
  width?: string;
  onChange?: ((value: string, option: DefaultOptionType | DefaultOptionType[] | undefined) => void) | undefined;
}

export const RequestPrioritySelect: React.FC<IProps> = memo(
  ({ hideFirstOption = false, disabled = false, value, width = 120, onChange }) => {
    return (
      <Select
        disabled={disabled}
        placeholder={L('Priority')}
        style={{ width }}
        value={value}
        onChange={onChange}
      >
        {!hideFirstOption && <Option value={undefined}>{L('All')}</Option>}
        <Option value="High">
          <Text style={{ color: '#F5222D' }}>{L('High')}</Text>
        </Option>
        <Option value="Medium">
          <Text style={{ color: '#1890FF' }}>{L('Medium')}</Text>
        </Option>
        <Option value="Low">
          <Text style={{ color: '#638A00' }}>{L('Low')}</Text>
        </Option>
      </Select>
    );
  }
);
